import {
  BLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
  BLOCKCUSTOMEROPERATIONSLIST_FAILED,
  RESET_BLOCKCUSTOMEROPERATIONSLIST,
  LOADING_BLOCKCUSTOMEROPERATIONSLIST,
  NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BLOCKCUSTOMEROPERATIONSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case BLOCKCUSTOMEROPERATIONSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case BLOCKCUSTOMEROPERATIONSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_BLOCKCUSTOMEROPERATIONSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
